import { useQuery } from '@tanstack/react-query';

import { fetchOrganizerCollectionPublicEventCounts } from '@/api/clients/organizer-collections-public-api';

const STALE_MS = 2 * 60 * 1000;

export function useOrganizerCollectionEventCounts(organizerId: string, enabled: boolean) {
  return useQuery({
    queryKey: ['organizer-collection-public-event-counts', organizerId],
    queryFn: () => fetchOrganizerCollectionPublicEventCounts(organizerId),
    enabled: Boolean(organizerId) && enabled,
    staleTime: STALE_MS,
  });
}
